import React from "react"
// components
import {
  Form,
  Label,
  Button,
  Card,
  Icon,
  Modal,
  Radio,
  Loader,
  Segment,
} from "semantic-ui-react"
import { Link, withRouter } from "react-router-dom"
import { Field } from "formik"
import firebase from "../config/firebaseConfig"
import InputMask from "react-input-mask"
import bind from "bind-decorator"
import { withTranslation } from "react-i18next"

const Checkbox = ({ field: { nds, onChange } }) => {
  return (
    <Form.Checkbox
      label="Плательщик НДС"
      checked={nds}
      onChange={onChange}
      id="nds"
      name="nds"
    />
  )
}

@withRouter
class FirstStep extends React.Component {
  state = {
    first_check: false,
    second_check: false,
    third_check: false,
    modalOne: false,
    modalTwo: false,
    active: false,
  }
  componentDidMount() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      { size: "invisible" },
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.props.takeNumbers(this.state)
    }
  }

  handleCheck = (e) => {
    const { services } = this.props.values
    if (e.target.id === "1") {
      this.setState({
        first_check: !this.state.first_check,
      })
      if (services.indexOf(1) === -1) {
        services.push(1)
      } else {
        for (let i = 0; i < services.length; i++) {
          if (services[i] === 1) {
            services.splice(i, 1)
          }
        }
      }
    }
    if (e.target.id === "2") {
      this.setState({
        second_check: !this.state.second_check,
      })
      if (services.indexOf(2) === -1) {
        services.push(2)
      } else {
        for (let i = 0; i < services.length; i++) {
          if (services[i] === 2) {
            services.splice(i, 1)
          }
        }
      }
    }
    if (e.target.id === "3") {
      this.setState({
        third_check: !this.state.third_check,
      })
      if (services.indexOf(3) === -1) {
        services.push(3)
      } else {
        for (let i = 0; i < services.length; i++) {
          if (services[i] === 3) {
            services.splice(i, 1)
          }
        }
      }
    }
  }

  @bind
  handleModalOne() {
    this.setState({
      modalOne: !this.state.modalOne,
    })
  }

  @bind
  handleModalTwo() {
    this.setState({
      modalTwo: !this.state.modalTwo,
    })
  }

  @bind
  keyPressed(event) {
    if (event.key === "Enter") {
      document.getElementById("recaptcha-container").click()
    }
  }
  render() {
    const { t } = this.props
    const {
      values: {
        email,
        iinOrBin,
        serialNds,
        numberNds,
        fio,
        phone,
        pass,
        rePass,
        nds,
      },
      errors,
      touched,
      setFieldTouched,
      handleChange,
      handleSubmit,
      clickable,
      clickable2,
      step,
      dirty,
      stepOne,
      stepTwo,
      stepThree,
      stepFour,
      prevStep,
      setFieldValue,
      code,
      saveErrMsg,
      saveScssMsg,
    } = this.props
    console.log(this.props.values.services)

    const change = (name, e) => {
      if (name === "iinOrBin") {
        this.setState({ active: true })
      }
      e.persist()
      handleChange(e)
      setFieldTouched(name, true, false)
    }

    const save = (name, e) => {
      if (name === "iinOrBin") {
        if (e.target.value.length === 12) {
          this.props.getUserInfo(e.target.value)
        }
      }
      this.setState({
        [name]: e.target.value,
      })
    }

    const data = [
      {
        value: iinOrBin,
        placeholder: `${t("UIN")}/${t("BIN")}`,
        name: "iinOrBin",
        type: "text",
      },
      {
        value: phone,
        placeholder: t("phoneNumber"),
        name: "phone",
        type: "text",
      },
    ]
    return (
      <>
        {step === 1 && (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      float: "right",
                      transform: "translate(40px, -20px)",
                      cursor: "pointer",
                      padding: "5px",
                    }}
                    onClick={this.handleModalOne}
                  >
                    <Icon name="question circle" size="large" color="green" />
                  </div>
                  <h2>{t("registration")}</h2>
                  <h3>{t("step")} №1</h3>
                </div>

                <div className="login-page-form">
                  <Form>
                    {data.map((item, idx) => {
                      const { name, value, type, placeholder } = item
                      return (
                        <Form.Field key={idx}>
                          {name === "iinOrBin" ? (
                            <>
                              <InputMask
                                mask="999999999999"
                                onChange={change.bind(null, name)}
                                onBlur={save.bind(null, name)}
                                value={value}
                                maskChar=""
                              >
                                {(inputProps) => (
                                  <Form.Input
                                    {...inputProps}
                                    name={name}
                                    label={placeholder}
                                    error={
                                      touched[name] && Boolean(errors[name])
                                    }
                                    id={name}
                                    placeholder={item.placeholder}
                                    // onChange={change.bind(null, name)}
                                    // onBlur={save.bind(null, name)}
                                    // value={value}
                                    type={type}
                                  />
                                )}
                              </InputMask>
                              {!this.props.errMsg &&
                              !this.props.scssMsg &&
                              this.state.active ? (
                                <>
                                  <div>
                                    <Segment
                                      style={{
                                        border: "0px solid red",
                                        boxShadow: "0 0",
                                      }}
                                    >
                                      <Loader active />
                                      Проверка ИИН
                                    </Segment>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              {this.props.errMsg && (
                                <>
                                  <p style={{ color: "red" }}>
                                    {this.props.errMsg}
                                  </p>
                                  <div
                                    style={{
                                      border: "1px solid grey",
                                      padding: "3px 5px",
                                    }}
                                  >
                                    <p
                                      align="justify"
                                      style={{
                                        fontSize: "13px",
                                      }}
                                    >
                                      Согласно Закону Республики Казахстан от 29
                                      марта 2016 года «О внесении изменений и
                                      дополнений в некоторые законодательные
                                      акты Республики Казахстан по вопросам
                                      сокращения разрешительных документов и
                                      упрощения разрешительных процедур»
                                      постановка на учет в качестве
                                      индивидуального предпринимателя
                                      осуществляется на портале электронного
                                      лицензирования
                                    </p>
                                    <Button
                                      content="Стать предпринимателем"
                                      color="green"
                                      style={{ marginBottom: "2px" }}
                                      onClick={() =>
                                        window.open(
                                          'https://elicense.kz/LicensingContent/Passport?servicesType=El4&servicesParameters=%7B"PackageCode"%3A"2016.МФ.У3"%2C"ServiceCode"%3A"2016.МФ.У3_1"%2C"VersionPackage"%3A"1.0.0"%2C"OperationTypeId"%3A"1"%2C"ActivityTypeCode"%3A"EL4-U16_MF3-V1"%2C"SubActivityTypeCode"%3A"EL4-U16_MF3-V1-P1"%7D',
                                        )
                                      }
                                    />
                                  </div>
                                </>
                              )}
                              <p style={{ color: "green" }}>
                                {this.props.scssMsg}
                              </p>
                            </>
                          ) : (
                            <InputMask
                              mask="+7\ 999 999 99 99"
                              onChange={change.bind(null, name)}
                              onBlur={save.bind(null, name)}
                              value={value}
                              maskChar=""
                            >
                              {(inputProps) => (
                                <Form.Input
                                  {...inputProps}
                                  name={name}
                                  label={placeholder}
                                  error={touched[name] && Boolean(errors[name])}
                                  id={name}
                                  placeholder={item.placeholder}
                                  // onChange={change.bind(null, name)}
                                  // onBlur={save.bind(null, name)}
                                  // value={value}
                                  type={type}
                                  // onKeyPress={this.keyPressed}
                                />
                              )}
                            </InputMask>
                          )}
                          {touched[name] && errors[name] && (
                            <Label basic color="red" pointing>
                              {errors[name]}
                            </Label>
                          )}
                        </Form.Field>
                      )
                    })}
                    <Button
                      style={{ marginTop: 15 }}
                      content={t("back")}
                      color="green"
                      as={Link}
                      to="/"
                      onClick={() => {
                        saveErrMsg("")
                        saveScssMsg("")
                      }}
                    />
                    <Button
                      style={{ marginTop: 15 }}
                      id="recaptcha-container"
                      className="recaptcha-container"
                      content={t("next")}
                      color="green"
                      disabled={
                        !!(errors.phone || errors.iinOrBin) ||
                        !dirty ||
                        !this.props.isOwner.Success ||
                        !clickable
                      }
                      onClick={stepOne}
                    />
                  </Form>
                  {/* <>
                    <Button
                      style={{ marginTop: 15 }}
                      content="Назад"
                      color="green"
                      as={Link}
                      to="/"
                    />
                    <Button
                      style={{ marginTop: 15 }}
                      id="recaptcha-container"
                      className="recaptcha-container"
                      content="Далее"
                      color="green"
                      disabled={
                        !!(errors.phone || errors.iinOrBin) ||
                        !dirty ||
                        !this.props.isOwner.Success ||
                        !clickable
                      }
                      onClick={stepOne}
                    />
                  </> */}
                </div>
              </Card.Content>
            </Card>
            <Modal
              open={this.state.modalOne}
              style={{ position: "fixed", top: "20%" }}
              size="small"
            >
              <Modal.Header
                style={{ backgroundColor: "#00B100", color: "white" }}
              >
                Инструкция
                <span
                  style={{ float: "right", cursor: "pointer" }}
                  onClick={this.handleModalOne}
                >
                  <Icon name="close" />
                </span>
              </Modal.Header>
              <Modal.Content scrolling>
                <p align="justify">
                  <span
                    style={{
                      color: "#00B100",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    {t("step")} 1.{" "}
                  </span>
                  Ввести ИИН (если у вас ИП) или БИН (если у вас ТОО) и номер
                  телефона. Важно ввести действующий номер, которым вы
                  пользуетесь, потому что именно на этот номер придет код
                  подтверждения для входа в аккаунт.
                </p>
                <br />

                <p align="justify">
                  <span
                    style={{
                      color: "#00B100",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    {t("step")} 2.{" "}
                  </span>
                  Нажмите кнопку “Далее”. Перед вами появилась пустая строчка,
                  куда нужно написать код-пароль, который уже отправлен на ваш
                  телефон.
                </p>
              </Modal.Content>
            </Modal>
          </div>
        )}
        {step === 2 && (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <h2>Регистрация</h2>
                  <h3>{t("step")} №2</h3>
                </div>

                <Form onSubmit={handleSubmit}>
                  <InputMask
                    mask="999999"
                    onChange={change.bind(null, "code")}
                    onBlur={save.bind(null, "code")}
                    value={code}
                    maskChar=""
                  >
                    {(inputProps) => (
                      <Form.Input
                        name="code"
                        id="code"
                        placeholder="Введите код подтверждения, отправленный Вам на номер мобильного телефона"
                        autoFocus
                      />
                    )}
                  </InputMask>
                  <p
                    style={{
                      fontSize: "13px",
                      marginTop: "-15px",
                      color: "grey",
                    }}
                  >
                    * Введите код-пароль отправленный Вам на номер
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {/* <Button
                    style={{ marginTop: 15 }}
                    content="Назад"
                    color="green"
                    onClick={prevStep}
                    /> */}
                    <Button
                      style={{ marginTop: 10 }}
                      color="green"
                      onClick={stepTwo}
                      disabled={!clickable2}
                    >
                      {t("next")}
                    </Button>
                  </div>
                </Form>
                <span
                  style={{ color: "grey", fontSize: "12px", marginTop: "15px" }}
                >
                  Нажимая кнопку &quot;Далее&quot;, Вы даете согласие на
                  обработку персональных данных, согласно действующего
                  законодательства Республики Казахстан
                </span>
                <a
                  style={{
                    float: "left",
                    marginTop: "10px",
                    color: "grey",
                    textDecoration: "underline",
                  }}
                  onClick={() => location.reload()}
                >
                  Не получили смс-код?
                </a>
              </Card.Content>
            </Card>
          </div>
        )}
        {step === 3 && (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <h2>{t("registration")}</h2>
                  <h3>{t("step")} №3</h3>
                </div>
                <p style={{ marginBottom: "10px" }}>
                  <b>Выберите функции, которые вам нужны в работе. На выбор:</b>
                </p>
                <Form onSubmit={handleSubmit}>
                  {this.props.services.map((s, i) => (
                    <Form.Checkbox
                      key={s.id}
                      label={s.name}
                      id={s.id}
                      onChange={this.handleCheck}
                      checked={
                        i === 0
                          ? this.state.third_check
                          : i === 1
                          ? this.state.second_check
                          : i === 2
                          ? this.state.first_check
                          : false
                      }
                    />
                  ))}
                </Form>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    style={{ marginTop: 15 }}
                    content="Назад"
                    color="green"
                    onClick={prevStep}
                  />
                  <Button
                    style={{ marginTop: 15 }}
                    color="green"
                    onClick={stepThree}
                    disabled={this.props.values.services.length === 0}
                  >
                    {t("next")}
                  </Button>
                </div>
              </Card.Content>
            </Card>
          </div>
        )}
        {step === 4 && (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <h2>{t("registration")}</h2>
                  <h3>{t("step")} №4</h3>
                </div>
                <Radio label="Пробный период" checked={false} />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    style={{ marginTop: 15 }}
                    content="Назад"
                    color="green"
                    onClick={prevStep}
                  />
                  <Button
                    style={{ marginTop: 15 }}
                    color="green"
                    onClick={stepFour}
                    disabled={this.props.values.services.length === 0}
                  >
                    {t("next")}
                  </Button>
                </div>
              </Card.Content>
            </Card>
          </div>
        )}
        {step === 5 && (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      float: "right",
                      transform: "translate(40px, -20px)",
                      cursor: "pointer",
                      padding: "5px",
                    }}
                    onClick={this.handleModalTwo}
                  >
                    <Icon name="question circle" size="large" color="green" />
                  </div>
                  <h2>{t("registration")}</h2>
                  <h3>{t("step")} №5</h3>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Form.Input
                    label="Логин"
                    // error={touched.login && Boolean(errors.login)}
                    name="iinOrBin"
                    id="iinOrBin"
                    placeholder="Логин"
                    onChange={change.bind(null, "login")}
                    value={iinOrBin}
                    disabled
                  />
                  {/* touched.login && errors.login && (
                    <Label basic color="red" pointing>
                      {errors.login}
                    </Label>
                  ) */}
                  {/* <Form.Input
                    label="ИИН/БИН"
                    name={iinOrBin}
                    id="iinOrBin"
                    placeholder="ИИН/БИН"
                    value={iinOrBin}
                    disabled
                  /> */}
                  <Form.Input
                    // className="input__organizationName"
                    // error={
                    //   touched.organizationName &&
                    //   Boolean(errors.organizationName)
                    // }
                    name="organizationName"
                    id="organizationName"
                    labelPosition="left"
                    label="Наименование организации"
                    placeholder="Наименование организации"
                    onChange={change.bind(null, "organizationName")}
                    value={
                      this.props.isOwner.obj ? this.props.isOwner.obj.name : ""
                    }
                    disabled
                  />
                  {/* touched.organizationName && errors.organizationName && (
                    <Label basic color="red" pointing>
                      {errors.organizationName}
                    </Label>
                  ) */}
                  <Form.TextArea
                    name="address"
                    // error={touched.address && Boolean(errors.address)}
                    id="address"
                    label="Юридический адрес"
                    onChange={change.bind(null, "address")}
                    value={
                      this.props.isOwner.obj
                        ? this.props.isOwner.obj.katoAddress
                        : ""
                    }
                    disabled
                  />
                  {/* touched.address && errors.address && (
                    <Label basic color="red" pointing>
                      {errors.address}
                    </Label>
                  ) */}
                  <Field component={Checkbox} name="nds" id="nds" />
                  {nds && (
                    <>
                      <Form.Input
                        label="Серия"
                        error={touched.serialNds && Boolean(errors.serialNds)}
                        name="serialNds"
                        id="serialNds"
                        placeholder="Серия НДС"
                        onChange={change.bind(null, "serialNds")}
                        value={serialNds}
                        type="number"
                      />
                      {touched.serialNds && errors.serialNds && (
                        <Label basic color="red" pointing>
                          {errors.serialNds}
                        </Label>
                      )}
                      <Form.Input
                        label="Номер свидетельства"
                        error={touched.numberNds && Boolean(errors.numberNds)}
                        name="numberNds"
                        id="numberNds"
                        placeholder="Номер НДС"
                        onChange={change.bind(null, "numberNds")}
                        value={numberNds}
                        type="number"
                      />
                      {touched.numberNds && errors.numberNds && (
                        <Label basic color="red" pointing>
                          {errors.numberNds}
                        </Label>
                      )}
                    </>
                  )}
                  <Form.Input
                    label="Ф.И.О."
                    // error={touched.fio && Boolean(errors.fio)}
                    name="fio"
                    id="fio"
                    placeholder="Ф.И.О."
                    onChange={change.bind(null, "fio")}
                    value={
                      this.props.isOwner.obj ? this.props.isOwner.obj.fio : fio
                    }
                    disabled
                  />
                  {/* touched.fio && errors.fio && (
                    <Label basic color="red" pointing>
                      {errors.fio}
                    </Label>
                  ) */}
                  <Form.Dropdown
                    search
                    selection
                    label="Налоговый орган"
                    // error={touched.taxOffice && Boolean(errors.taxOffice)}
                    name="taxRegions"
                    id="taxRegions"
                    placeholder="Регион"
                    onChange={(e, { value }) => {
                      setFieldValue("taxRegions", value)
                      this.props.selectTaxRegion(value)
                    }}
                    // onChange={change.bind(null, "taxOfficeID")}
                    options={this.props.taxRegions}
                  />
                  <Form.Dropdown
                    search
                    selection
                    error={touched.taxOffice && Boolean(errors.taxOffice)}
                    name="taxOffice"
                    id="taxOffice"
                    placeholder="Налоговый орган"
                    onChange={(e, { value }) =>
                      setFieldValue("taxOffice", value)
                    }
                    // onChange={change.bind(null, "taxOfficeID")}
                    options={this.props.taxOffices}
                  />
                  {touched.taxOffice && errors.taxOffice && (
                    <Label basic color="red" pointing>
                      {errors.taxOffice}
                    </Label>
                  )}
                  <Form.Select
                    label="Тип налога"
                    error={touched.taxTypes && Boolean(errors.taxTypes)}
                    name="taxTypes"
                    id="taxTypes"
                    placeholder="Тип налога"
                    onChange={(e, { value }) =>
                      setFieldValue("taxTypes", value)
                    }
                    // onChange={change.bind(null, "taxOfficeID")}
                    options={this.props.taxTypes}
                  />
                  {touched.taxTypes && errors.taxTypes && (
                    <Label basic color="red" pointing>
                      {errors.taxTypes}
                    </Label>
                  )}
                  <Form.Input
                    label="Код ОКЭД"
                    // error={touched.phone && Boolean(errors.phone)}
                    name="okedCode"
                    id="okedCode"
                    placeholder="Код ОКЭД"
                    onChange={change.bind(null, "okedCode")}
                    value={
                      this.props.isOwner.obj
                        ? this.props.isOwner.obj.okedCode
                        : ""
                    }
                    disabled
                  />
                  {/* <Form.Input
                  label="Номер исполнительонго органа"
                  error={touched.taxOfficeID && Boolean(errors.taxOfficeID)}
                  name="taxOfficeID"
                  id="taxOfficeID"
                  placeholder="Номер исполнительонго органа"
                  onChange={change.bind(null, "taxOfficeID")}
                  value={taxOfficeID}
                  type="number"
                /> */}
                  {touched.taxOfficeID && errors.taxOfficeID && (
                    <Label basic color="red" pointing>
                      {errors.taxOfficeID}
                    </Label>
                  )}
                  <Form.Input
                    label="Email"
                    error={touched.email && Boolean(errors.email)}
                    name="email"
                    id="email"
                    placeholder="Email"
                    onChange={change.bind(null, "email")}
                    value={email}
                    type="text"
                  />
                  {touched.email && errors.email && (
                    <Label basic color="red" pointing>
                      {errors.email}
                    </Label>
                  )}
                  <Form.Input
                    label="Пароль"
                    error={touched.pass && Boolean(errors.pass)}
                    name="pass"
                    id="pass"
                    placeholder="Пароль"
                    onChange={change.bind(null, "pass")}
                    value={pass}
                    type="password"
                  />
                  {touched.pass && errors.pass && (
                    <Label basic color="red" pointing>
                      {errors.pass}
                    </Label>
                  )}
                  <Form.Input
                    label="Подтверждение пароля"
                    error={touched.rePass && Boolean(errors.rePass)}
                    name="rePass"
                    id="rePass"
                    placeholder="Повторите пароль"
                    onChange={change.bind(null, "rePass")}
                    value={rePass}
                    type="password"
                  />
                  {touched.rePass && errors.rePass && (
                    <Label basic color="red" pointing>
                      {errors.rePass}
                    </Label>
                  )}
                </Form>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    style={{ marginTop: 15 }}
                    content="Назад"
                    color="green"
                    onClick={prevStep}
                  />
                  <Button
                    style={{ marginTop: 15 }}
                    onClick={handleSubmit}
                    color="green"
                  >
                    Зарегистрироваться
                  </Button>
                </div>
              </Card.Content>
            </Card>
            <Modal
              open={this.state.modalTwo}
              style={{ position: "fixed", top: "20%" }}
              size="small"
            >
              <Modal.Header
                style={{ backgroundColor: "#00B100", color: "white" }}
              >
                Инструкция
                <span
                  style={{ float: "right", cursor: "pointer" }}
                  onClick={this.handleModalTwo}
                >
                  <Icon name="close" />
                </span>
              </Modal.Header>
              <Modal.Content scrolling>
                <p align="justify">
                  Заполнить анкетные данные. Некоторые данные уже заполнены,
                  остается только:
                </p>
                <ul>
                  <li>налоговый орган</li>
                  <li>тип налога</li>
                  <li>действующий адрес электронной почты</li>
                  <li>пароль для вашего акаунта</li>
                </ul>
                <p>
                  Нажмите кнопку “Зарегистрироваться”. Поздравляем! Регистрация
                  прошла успешно!
                </p>
                <br />

                <p align="justify">
                  После завершения регистрации, вы сможете войти в систему
                  Smartkassa. Для входа используйте ИИН/БИН и созданный вами
                  пароль.
                </p>
              </Modal.Content>
            </Modal>
          </div>
        )}
      </>
    )
  }
}

export default withTranslation()(FirstStep)

// import React from "react"
// // components
// import {
//   Form,
//   Label,
//   Button,
//   Card,
//   Icon,
//   Modal,
//   Radio,
// } from "semantic-ui-react"
// import { Link, withRouter } from "react-router-dom"
// import { Field } from "formik"
// import firebase from "../config/firebaseConfig"
// import InputMask from "react-input-mask"
// import bind from "bind-decorator"
// // import { withTranslation } from "react-i18next"

// const Checkbox = ({ field: { nds, onChange } }) => {
//   return (
//     <Form.Checkbox
//       label="Плательщик НДС"
//       checked={nds}
//       onChange={onChange}
//       id="nds"
//       name="nds"
//     />
//   )
// }

// @withRouter
// class FirstStep extends React.Component {
//   state = {
//     first_check: false,
//     second_check: false,
//     third_check: false,
//     modalOne: false,
//     modalTwo: false,
//   }
//   componentDidMount() {
//     window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
//       "recaptcha-container",
//       { size: "invisible" },
//     )
//   }

//   componentDidUpdate(prevProps, prevState) {
//     if (this.state !== prevState) {
//       this.props.takeNumbers(this.state)
//     }
//   }

//   handleCheck = (e) => {
//     const { services } = this.props.values
//     if (e.target.id === "1") {
//       this.setState({
//         first_check: !this.state.first_check,
//       })
//       if (services.indexOf(1) === -1) {
//         services.push(1)
//       } else {
//         for (let i = 0; i < services.length; i++) {
//           if (services[i] === 1) {
//             services.splice(i, 1)
//           }
//         }
//       }
//     }
//     if (e.target.id === "2") {
//       this.setState({
//         second_check: !this.state.second_check,
//       })
//       if (services.indexOf(2) === -1) {
//         services.push(2)
//       } else {
//         for (let i = 0; i < services.length; i++) {
//           if (services[i] === 2) {
//             services.splice(i, 1)
//           }
//         }
//       }
//     }
//     if (e.target.id === "3") {
//       this.setState({
//         third_check: !this.state.third_check,
//       })
//       if (services.indexOf(3) === -1) {
//         services.push(3)
//       } else {
//         for (let i = 0; i < services.length; i++) {
//           if (services[i] === 3) {
//             services.splice(i, 1)
//           }
//         }
//       }
//     }
//   }

//   @bind
//   handleModalOne() {
//     this.setState({
//       modalOne: !this.state.modalOne,
//     })
//   }

//   @bind
//   handleModalTwo() {
//     this.setState({
//       modalTwo: !this.state.modalTwo,
//     })
//   }

//   @bind
//   keyPressed(event) {
//     if (event.key === "Enter") {
//       document.getElementById("recaptcha-container").click()
//     }
//   }
//   render() {
//     const { t } = this.props
//     const {
//       values: {
//         email,
//         iinOrBin,
//         serialNds,
//         numberNds,
//         fio,
//         phone,
//         pass,
//         rePass,
//         nds,
//       },
//       errors,
//       touched,
//       setFieldTouched,
//       handleChange,
//       handleSubmit,
//       clickable,
//       clickable2,
//       step,
//       dirty,
//       stepOne,
//       stepTwo,
//       stepThree,
//       stepFour,
//       prevStep,
//       setFieldValue,
//       code,
//     } = this.props

//     const change = (name, e) => {
//       e.persist()
//       handleChange(e)
//       setFieldTouched(name, true, false)
//     }

//     const save = (name, e) => {
//       if (name === "iinOrBin") {
//         if (e.target.value.length === 12) {
//           this.props.getUserInfo(e.target.value)
//         }
//       }
//       this.setState({
//         [name]: e.target.value,
//       })
//     }

//     const data = [
//       {
//         value: iinOrBin,
//         placeholder: `${"ИИН"}/${"БИН"}`,
//         name: "iinOrBin",
//         type: "text",
//       },
//       {
//         value: phone,
//         placeholder: "Телефон",
//         name: "phone",
//         type: "text",
//       },
//     ]
//     return (
//       <>
//         {step === 1 && (
//           <div className="login-page-holder">
//             <Card fluid className="login-page">
//               <Card.Content>
//                 <div className="login-page-title">
//                   <div className="flipper-container">
//                     <div className="flipper flipper-front">
//                       <img
//                         className="login-page-img"
//                         src={require(`../assets/img/logo.png`)}
//                       />
//                     </div>
//                     <div className="flipper flipper-back">
//                       <div className="login-page-spinner">
//                         <div className="spinner">
//                           <div className="rect1" />
//                           <div className="rect2" />
//                           <div className="rect3" />
//                           <div className="rect4" />
//                           <div className="rect5" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     style={{
//                       float: "right",
//                       transform: "translate(40px, -20px)",
//                       cursor: "pointer",
//                       padding: "5px",
//                     }}
//                     onClick={this.handleModalOne}
//                   >
//                     <Icon name="question circle" size="large" color="green" />
//                   </div>
//                   <h2>{"Регистрация"}</h2>
//                   <h3>{"Шаг"} №1</h3>
//                 </div>

//                 <div className="login-page-form">
//                   <Form>
//                     {data.map((item, idx) => {
//                       const { name, value, type, placeholder } = item
//                       return (
//                         <Form.Field key={idx}>
//                           {name === "iinOrBin" ? (
//                             <>
//                               <InputMask
//                                 mask="999999999999"
//                                 onChange={change.bind(null, name)}
//                                 onBlur={save.bind(null, name)}
//                                 value={value}
//                               >
//                                 {(inputProps) => (
//                                   <Form.Input
//                                     {...inputProps}
//                                     name={name}
//                                     label={placeholder}
//                                     error={
//                                       touched[name] && Boolean(errors[name])
//                                     }
//                                     id={name}
//                                     placeholder={item.placeholder}
//                                     // onChange={change.bind(null, name)}
//                                     // onBlur={save.bind(null, name)}
//                                     // value={value}
//                                     type={type}
//                                   />
//                                 )}
//                               </InputMask>
//                               {this.props.errMsg && (
//                                 <>
//                                   <p style={{ color: "red" }}>
//                                     {this.props.errMsg}
//                                   </p>
//                                   <div
//                                     style={{
//                                       border: "1px solid grey",
//                                       padding: "3px 5px",
//                                     }}
//                                   >
//                                     <p
//                                       align="justify"
//                                       style={{
//                                         fontSize: "13px",
//                                       }}
//                                     >
//                                       Согласно Закону Республики Казахстан от 29
//                                       марта 2016 года «О внесении изменений и
//                                       дополнений в некоторые законодательные
//                                       акты Республики Казахстан по вопросам
//                                       сокращения разрешительных документов и
//                                       упрощения разрешительных процедур»
//                                       постановка на учет в качестве
//                                       индивидуального предпринимателя
//                                       осуществляется на портале электронного
//                                       лицензирования
//                                     </p>
//                                     <Button
//                                       content="Стать предпринимателем"
//                                       color="green"
//                                       style={{ marginBottom: "2px" }}
//                                       onClick={() =>
//                                         window.open(
//                                           'https://elicense.kz/LicensingContent/Passport?servicesType=El4&servicesParameters=%7B"PackageCode"%3A"2016.МФ.У3"%2C"ServiceCode"%3A"2016.МФ.У3_1"%2C"VersionPackage"%3A"1.0.0"%2C"OperationTypeId"%3A"1"%2C"ActivityTypeCode"%3A"EL4-U16_MF3-V1"%2C"SubActivityTypeCode"%3A"EL4-U16_MF3-V1-P1"%7D',
//                                         )
//                                       }
//                                     />
//                                   </div>
//                                 </>
//                               )}
//                               <p style={{ color: "green" }}>
//                                 {this.props.scssMsg}
//                               </p>
//                             </>
//                           ) : (
//                             <InputMask
//                               mask="+7\ 999 999 99 99"
//                               onChange={change.bind(null, name)}
//                               onBlur={save.bind(null, name)}
//                               value={value}
//                             >
//                               {(inputProps) => (
//                                 <Form.Input
//                                   {...inputProps}
//                                   name={name}
//                                   label={placeholder}
//                                   error={touched[name] && Boolean(errors[name])}
//                                   id={name}
//                                   placeholder={item.placeholder}
//                                   // onChange={change.bind(null, name)}
//                                   // onBlur={save.bind(null, name)}
//                                   // value={value}
//                                   type={type}
//                                   // onKeyPress={this.keyPressed}
//                                 />
//                               )}
//                             </InputMask>
//                           )}
//                           {touched[name] && errors[name] && (
//                             <Label basic color="red" pointing>
//                               {errors[name]}
//                             </Label>
//                           )}
//                         </Form.Field>
//                       )
//                     })}
//                     <Button
//                       style={{ marginTop: 15 }}
//                       content={"Назад"}
//                       color="green"
//                       as={Link}
//                       to="/"
//                     />
//                     <Button
//                       style={{ marginTop: 15 }}
//                       id="recaptcha-container"
//                       className="recaptcha-container"
//                       content={"Далее"}
//                       color="green"
//                       disabled={
//                         !!(errors.phone || errors.iinOrBin) ||
//                         !dirty ||
//                         !this.props.isOwner.Success ||
//                         !clickable
//                       }
//                       onClick={stepOne}
//                     />
//                   </Form>
//                   {/* <>
//                     <Button
//                       style={{ marginTop: 15 }}
//                       content="Назад"
//                       color="green"
//                       as={Link}
//                       to="/"
//                     />
//                     <Button
//                       style={{ marginTop: 15 }}
//                       id="recaptcha-container"
//                       className="recaptcha-container"
//                       content="Далее"
//                       color="green"
//                       disabled={
//                         !!(errors.phone || errors.iinOrBin) ||
//                         !dirty ||
//                         !this.props.isOwner.Success ||
//                         !clickable
//                       }
//                       onClick={stepOne}
//                     />
//                   </> */}
//                 </div>
//               </Card.Content>
//             </Card>
//             <Modal
//               open={this.state.modalOne}
//               style={{ position: "fixed", top: "20%" }}
//               size="small"
//             >
//               <Modal.Header
//                 style={{ backgroundColor: "#00B100", color: "white" }}
//               >
//                 Инструкция
//                 <span
//                   style={{ float: "right", cursor: "pointer" }}
//                   onClick={this.handleModalOne}
//                 >
//                   <Icon name="close" />
//                 </span>
//               </Modal.Header>
//               <Modal.Content scrolling>
//                 <p align="justify">
//                   <span
//                     style={{
//                       color: "#00B100",
//                       fontWeight: "bold",
//                       fontSize: "16px",
//                     }}
//                   >
//                     {"step"} 1.{" "}
//                   </span>
//                   Ввести ИИН (если у вас ИП) или БИН (если у вас ТОО) и номер
//                   телефона. Важно ввести действующий номер, которым вы
//                   пользуетесь, потому что именно на этот номер придет код
//                   подтверждения для входа в аккаунт.
//                 </p>
//                 <br />

//                 <p align="justify">
//                   <span
//                     style={{
//                       color: "#00B100",
//                       fontWeight: "bold",
//                       fontSize: "16px",
//                     }}
//                   >
//                     {"step"} 2.{" "}
//                   </span>
//                   Нажмите кнопку “Далее”. Перед вами появилась пустая строчка,
//                   куда нужно написать код-пароль, который уже отправлен на ваш
//                   телефон.
//                 </p>
//               </Modal.Content>
//             </Modal>
//           </div>
//         )}
//         {step === 2 && (
//           <div className="login-page-holder">
//             <Card fluid className="login-page">
//               <Card.Content>
//                 <div className="login-page-title">
//                   <div className="flipper-container">
//                     <div className="flipper flipper-front">
//                       <img
//                         className="login-page-img"
//                         src={require(`../assets/img/logo.png`)}
//                       />
//                     </div>
//                     <div className="flipper flipper-back">
//                       <div className="login-page-spinner">
//                         <div className="spinner">
//                           <div className="rect1" />
//                           <div className="rect2" />
//                           <div className="rect3" />
//                           <div className="rect4" />
//                           <div className="rect5" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <h2>Регистрация</h2>
//                   <h3>{"Шаг"} №2</h3>
//                 </div>

//                 <Form onSubmit={handleSubmit}>
//                   <InputMask
//                     mask="999999"
//                     onChange={change.bind(null, "code")}
//                     onBlur={save.bind(null, "code")}
//                     value={code}
//                   >
//                     {(inputProps) => (
//                       <Form.Input
//                         name="code"
//                         id="code"
//                         placeholder="Введите код подтверждения, отправленный Вам на номер мобильного телефона"
//                         autoFocus
//                       />
//                     )}
//                   </InputMask>
//                   <p
//                     style={{
//                       fontSize: "13px",
//                       marginTop: "-15px",
//                       color: "grey",
//                     }}
//                   >
//                     * Введите код-пароль отправленный Вам на номер
//                   </p>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "center",
//                     }}
//                   >
//                     {/* <Button
//                     style={{ marginTop: 15 }}
//                     content="Назад"
//                     color="green"
//                     onClick={prevStep}
//                     /> */}
//                     <Button
//                       style={{ marginTop: 10 }}
//                       color="green"
//                       onClick={stepTwo}
//                       disabled={!clickable2}
//                     >
//                       {"next"}
//                     </Button>
//                   </div>
//                 </Form>
//                 <span
//                   style={{ color: "grey", fontSize: "12px", marginTop: "15px" }}
//                 >
//                   Нажимая кнопку &quot;Далее&quot;, Вы даете согласие на
//                   обработку персональных данных, согласно действующего
//                   законодательства Республики Казахстан
//                 </span>
//                 <a
//                   style={{
//                     float: "left",
//                     marginTop: "10px",
//                     color: "grey",
//                     textDecoration: "underline",
//                   }}
//                   onClick={() => location.reload()}
//                 >
//                   Не получили смс-код?
//                 </a>
//               </Card.Content>
//             </Card>
//           </div>
//         )}
//         {step === 3 && (
//           <div className="login-page-holder">
//             <Card fluid className="login-page">
//               <Card.Content>
//                 <div className="login-page-title">
//                   <div className="flipper-container">
//                     <div className="flipper flipper-front">
//                       <img
//                         className="login-page-img"
//                         src={require(`../assets/img/logo.png`)}
//                       />
//                     </div>
//                     <div className="flipper flipper-back">
//                       <div className="login-page-spinner">
//                         <div className="spinner">
//                           <div className="rect1" />
//                           <div className="rect2" />
//                           <div className="rect3" />
//                           <div className="rect4" />
//                           <div className="rect5" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <h2>{"Регистрация"}</h2>
//                   <h3>{"Шаг"} №3</h3>
//                 </div>
//                 <p style={{ marginBottom: "10px" }}>
//                   <b>Выберите функции, которые вам нужны в работе. На выбор:</b>
//                 </p>
//                 <Form onSubmit={handleSubmit}>
//                   {this.props.services.map((s) => (
//                     <Form.Checkbox
//                       key={s.id}
//                       label={s.name}
//                       id={s.id}
//                       onChange={this.handleCheck}
//                       // checked={this.state.first_check}
//                     />
//                   ))}
//                 </Form>
//                 <div style={{ display: "flex", justifyContent: "center" }}>
//                   <Button
//                     style={{ marginTop: 15 }}
//                     content="Назад"
//                     color="green"
//                     onClick={prevStep}
//                   />
//                   <Button
//                     style={{ marginTop: 15 }}
//                     color="green"
//                     onClick={stepThree}
//                     disabled={this.props.values.services.length === 0}
//                   >
//                     {"next"}
//                   </Button>
//                 </div>
//               </Card.Content>
//             </Card>
//           </div>
//         )}
//         {step === 4 && (
//           <div className="login-page-holder">
//             <Card fluid className="login-page">
//               <Card.Content>
//                 <div className="login-page-title">
//                   <div className="flipper-container">
//                     <div className="flipper flipper-front">
//                       <img
//                         className="login-page-img"
//                         src={require(`../assets/img/logo.png`)}
//                       />
//                     </div>
//                     <div className="flipper flipper-back">
//                       <div className="login-page-spinner">
//                         <div className="spinner">
//                           <div className="rect1" />
//                           <div className="rect2" />
//                           <div className="rect3" />
//                           <div className="rect4" />
//                           <div className="rect5" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <h2>{"Регистрация"}</h2>
//                   <h3>{"Шаг"} №4</h3>
//                 </div>
//                 <Radio label="Пробный период" />
//                 <div style={{ display: "flex", justifyContent: "center" }}>
//                   <Button
//                     style={{ marginTop: 15 }}
//                     content="Назад"
//                     color="green"
//                     onClick={prevStep}
//                   />
//                   <Button
//                     style={{ marginTop: 15 }}
//                     color="green"
//                     onClick={stepFour}
//                     disabled={this.props.values.services.length === 0}
//                   >
//                     {"next"}
//                   </Button>
//                 </div>
//               </Card.Content>
//             </Card>
//           </div>
//         )}
//         {step === 5 && (
//           <div className="login-page-holder">
//             <Card fluid className="login-page">
//               <Card.Content>
//                 <div className="login-page-title">
//                   <div className="flipper-container">
//                     <div className="flipper flipper-front">
//                       <img
//                         className="login-page-img"
//                         src={require(`../assets/img/logo.png`)}
//                       />
//                     </div>
//                     <div className="flipper flipper-back">
//                       <div className="login-page-spinner">
//                         <div className="spinner">
//                           <div className="rect1" />
//                           <div className="rect2" />
//                           <div className="rect3" />
//                           <div className="rect4" />
//                           <div className="rect5" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     style={{
//                       float: "right",
//                       transform: "translate(40px, -20px)",
//                       cursor: "pointer",
//                       padding: "5px",
//                     }}
//                     onClick={this.handleModalTwo}
//                   >
//                     <Icon name="question circle" size="large" color="green" />
//                   </div>
//                   <h2>{"registration"}</h2>
//                   <h3>{"Шаг"} №4</h3>
//                 </div>

//                 <Form onSubmit={handleSubmit}>
//                   <Form.Input
//                     label="Логин"
//                     // error={touched.login && Boolean(errors.login)}
//                     name="iinOrBin"
//                     id="iinOrBin"
//                     placeholder="Логин"
//                     onChange={change.bind(null, "login")}
//                     value={iinOrBin}
//                     disabled
//                   />
//                   {/* touched.login && errors.login && (
//                     <Label basic color="red" pointing>
//                       {errors.login}
//                     </Label>
//                   ) */}
//                   {/* <Form.Input
//                     label="ИИН/БИН"
//                     name={iinOrBin}
//                     id="iinOrBin"
//                     placeholder="ИИН/БИН"
//                     value={iinOrBin}
//                     disabled
//                   /> */}
//                   <Form.Input
//                     // className="input__organizationName"
//                     // error={
//                     //   touched.organizationName &&
//                     //   Boolean(errors.organizationName)
//                     // }
//                     name="organizationName"
//                     id="organizationName"
//                     labelPosition="left"
//                     label="Наименование организации"
//                     placeholder="Наименование организации"
//                     onChange={change.bind(null, "organizationName")}
//                     value={
//                       this.props.isOwner.obj ? this.props.isOwner.obj.name : ""
//                     }
//                     disabled
//                   />
//                   {/* touched.organizationName && errors.organizationName && (
//                     <Label basic color="red" pointing>
//                       {errors.organizationName}
//                     </Label>
//                   ) */}
//                   <Form.TextArea
//                     name="address"
//                     // error={touched.address && Boolean(errors.address)}
//                     id="address"
//                     label="Юридический адрес"
//                     onChange={change.bind(null, "address")}
//                     value={
//                       this.props.isOwner.obj
//                         ? this.props.isOwner.obj.katoAddress
//                         : ""
//                     }
//                     disabled
//                   />
//                   {/* touched.address && errors.address && (
//                     <Label basic color="red" pointing>
//                       {errors.address}
//                     </Label>
//                   ) */}
//                   <Field component={Checkbox} name="nds" id="nds" />
//                   {nds && (
//                     <>
//                       <Form.Input
//                         label="Серия"
//                         error={touched.serialNds && Boolean(errors.serialNds)}
//                         name="serialNds"
//                         id="serialNds"
//                         placeholder="Серия НДС"
//                         onChange={change.bind(null, "serialNds")}
//                         value={serialNds}
//                         type="number"
//                       />
//                       {touched.serialNds && errors.serialNds && (
//                         <Label basic color="red" pointing>
//                           {errors.serialNds}
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Номер свидетельства"
//                         error={touched.numberNds && Boolean(errors.numberNds)}
//                         name="numberNds"
//                         id="numberNds"
//                         placeholder="Номер НДС"
//                         onChange={change.bind(null, "numberNds")}
//                         value={numberNds}
//                         type="number"
//                       />
//                       {touched.numberNds && errors.numberNds && (
//                         <Label basic color="red" pointing>
//                           {errors.numberNds}
//                         </Label>
//                       )}
//                     </>
//                   )}
//                   <Form.Input
//                     label="Ф.И.О."
//                     // error={touched.fio && Boolean(errors.fio)}
//                     name="fio"
//                     id="fio"
//                     placeholder="Ф.И.О."
//                     onChange={change.bind(null, "fio")}
//                     value={
//                       this.props.isOwner.obj ? this.props.isOwner.obj.fio : fio
//                     }
//                     disabled
//                   />
//                   {/* touched.fio && errors.fio && (
//                     <Label basic color="red" pointing>
//                       {errors.fio}
//                     </Label>
//                   ) */}
//                   <Form.Dropdown
//                     search
//                     selection
//                     label="Налоговый орган"
//                     // error={touched.taxOffice && Boolean(errors.taxOffice)}
//                     name="taxRegions"
//                     id="taxRegions"
//                     placeholder="Регион"
//                     onChange={(e, { value }) => {
//                       setFieldValue("taxRegions", value)
//                       this.props.selectTaxRegion(value)
//                     }}
//                     // onChange={change.bind(null, "taxOfficeID")}
//                     options={this.props.taxRegions}
//                   />
//                   <Form.Dropdown
//                     search
//                     selection
//                     error={touched.taxOffice && Boolean(errors.taxOffice)}
//                     name="taxOffice"
//                     id="taxOffice"
//                     placeholder="Налоговый орган"
//                     onChange={(e, { value }) =>
//                       setFieldValue("taxOffice", value)
//                     }
//                     // onChange={change.bind(null, "taxOfficeID")}
//                     options={this.props.taxOffices}
//                   />
//                   {touched.taxOffice && errors.taxOffice && (
//                     <Label basic color="red" pointing>
//                       {errors.taxOffice}
//                     </Label>
//                   )}
//                   <Form.Select
//                     label="Тип налога"
//                     error={touched.taxTypes && Boolean(errors.taxTypes)}
//                     name="taxTypes"
//                     id="taxTypes"
//                     placeholder="Тип налога"
//                     onChange={(e, { value }) =>
//                       setFieldValue("taxTypes", value)
//                     }
//                     // onChange={change.bind(null, "taxOfficeID")}
//                     options={this.props.taxTypes}
//                   />
//                   {touched.taxTypes && errors.taxTypes && (
//                     <Label basic color="red" pointing>
//                       {errors.taxTypes}
//                     </Label>
//                   )}
//                   <Form.Input
//                     label="Код ОКЭД"
//                     // error={touched.phone && Boolean(errors.phone)}
//                     name="okedCode"
//                     id="okedCode"
//                     placeholder="Код ОКЭД"
//                     onChange={change.bind(null, "okedCode")}
//                     value={
//                       this.props.isOwner.obj
//                         ? this.props.isOwner.obj.okedCode
//                         : ""
//                     }
//                     disabled
//                   />
//                   {/* <Form.Input
//                   label="Номер исполнительонго органа"
//                   error={touched.taxOfficeID && Boolean(errors.taxOfficeID)}
//                   name="taxOfficeID"
//                   id="taxOfficeID"
//                   placeholder="Номер исполнительонго органа"
//                   onChange={change.bind(null, "taxOfficeID")}
//                   value={taxOfficeID}
//                   type="number"
//                 /> */}
//                   {touched.taxOfficeID && errors.taxOfficeID && (
//                     <Label basic color="red" pointing>
//                       {errors.taxOfficeID}
//                     </Label>
//                   )}
//                   <Form.Input
//                     label="Email"
//                     error={touched.email && Boolean(errors.email)}
//                     name="email"
//                     id="email"
//                     placeholder="Email"
//                     onChange={change.bind(null, "email")}
//                     value={email}
//                     type="text"
//                   />
//                   {touched.email && errors.email && (
//                     <Label basic color="red" pointing>
//                       {errors.email}
//                     </Label>
//                   )}
//                   <Form.Input
//                     label="Пароль"
//                     error={touched.pass && Boolean(errors.pass)}
//                     name="pass"
//                     id="pass"
//                     placeholder="Пароль"
//                     onChange={change.bind(null, "pass")}
//                     value={pass}
//                     type="password"
//                   />
//                   {touched.pass && errors.pass && (
//                     <Label basic color="red" pointing>
//                       {errors.pass}
//                     </Label>
//                   )}
//                   <Form.Input
//                     label="Подтверждение пароля"
//                     error={touched.rePass && Boolean(errors.rePass)}
//                     name="rePass"
//                     id="rePass"
//                     placeholder="Повторите пароль"
//                     onChange={change.bind(null, "rePass")}
//                     value={rePass}
//                     type="password"
//                   />
//                   {touched.rePass && errors.rePass && (
//                     <Label basic color="red" pointing>
//                       {errors.rePass}
//                     </Label>
//                   )}
//                 </Form>
//                 <div style={{ display: "flex", justifyContent: "center" }}>
//                   <Button
//                     style={{ marginTop: 15 }}
//                     content="Назад"
//                     color="green"
//                     onClick={prevStep}
//                   />
//                   <Button
//                     style={{ marginTop: 15 }}
//                     onClick={handleSubmit}
//                     color="green"
//                   >
//                     Зарегистрироваться
//                   </Button>
//                 </div>
//               </Card.Content>
//             </Card>
//             <Modal
//               open={this.state.modalTwo}
//               style={{ position: "fixed", top: "20%" }}
//               size="small"
//             >
//               <Modal.Header
//                 style={{ backgroundColor: "#00B100", color: "white" }}
//               >
//                 Инструкция
//                 <span
//                   style={{ float: "right", cursor: "pointer" }}
//                   onClick={this.handleModalTwo}
//                 >
//                   <Icon name="close" />
//                 </span>
//               </Modal.Header>
//               <Modal.Content scrolling>
//                 <p align="justify">
//                   Заполнить анкетные данные. Некоторые данные уже заполнены,
//                   остается только:
//                 </p>
//                 <ul>
//                   <li>налоговый орган</li>
//                   <li>тип налога</li>
//                   <li>действующий адрес электронной почты</li>
//                   <li>пароль для вашего акаунта</li>
//                 </ul>
//                 <p>
//                   Нажмите кнопку “Зарегистрироваться”. Поздравляем! Регистрация
//                   прошла успешно!
//                 </p>
//                 <br />

//                 <p align="justify">
//                   После завершения регистрации, вы сможете войти в систему
//                   Smartkassa. Для входа используйте ИИН/БИН и созданный вами
//                   пароль.
//                 </p>
//               </Modal.Content>
//             </Modal>
//           </div>
//         )}
//       </>
//     )
//   }
// }

// export default FirstStep
